import {Injectable} from '@angular/core';
import {DataStore} from '@aws-amplify/datastore';
import {Bonus, BonusStatus, BonusType, Contract, PermissionType, User} from '../../models';
import {CommercialRoles, ContractStatus, Percentages, Roles} from '../enums/enums';
import {DateTime} from "luxon";

@Injectable({
    providedIn: 'root',
})
export class AgentService {

    constructor() {
    }


    async setAgentLevel(agentId: string, contractValue = 0) {

        let user = await DataStore.query(User, agentId);
        let totalSoFar = user.totalActiveContracts;


        totalSoFar = totalSoFar + contractValue;

        // let's find the new role
        const roles = Object.values(CommercialRoles);
        const eligibleRoles = roles.filter(r => r.capital <= totalSoFar);
        const agentNewRole = eligibleRoles[eligibleRoles.length - 1] ?? roles[0];

        const agent = await DataStore.query(User, agentId);
        await DataStore.save(User.copyOf(agent, updated => {
            updated.role = agentNewRole.displayName;
            updated.totalActiveContracts = totalSoFar;
        }));
    }

    async getActiveContract(agentId) {
        let c = (await DataStore.query(Contract)).filter(c => c.commercial?.id == agentId && c.status == ContractStatus.ACTIVE);
        
        return c;
    }

    async setAgentLevelDry(agentId: string) {
        // get all contracts for this agent
        const contractsList = await this.getActiveContract(agentId);
        const totalSoFar = contractsList.reduce(function (a, b) {
            return a + b['amount'];
        }, 0);

        // let's find the new role
        const roles = Object.values(Roles);
        const eligibleRoles = roles.filter(r => r.capital <= totalSoFar);
        const agentNewRole = eligibleRoles[eligibleRoles.length - 1];

        const agent = await DataStore.query(User, agentId);

        /*  await DataStore.save(User.copyOf(agent, updated => {
              updated.role = agentNewRole.displayName;
          }));*/
    }

    async calcMonthlyBonus(contract: Contract) {
        
        const basePerc = Percentages.BASE;

        // @ts-ignore
        const eligibleCapitalPerc = Object.keys(Percentages.ON_CAPITAL).filter(r => r <= contract.amount);
        const capitalPerc = Percentages.ON_CAPITAL[eligibleCapitalPerc[eligibleCapitalPerc.length - 1]];

        const contractDurationInYears = parseInt((this.dateDiffInDays(contract.startDate, contract.endDate) / 365).toString());

        const eligibleAnnualPerc = Object.keys(Percentages.ON_YEARS).filter(r => parseFloat(r) <= contractDurationInYears);
        const annualPerc = Percentages.ON_YEARS[eligibleAnnualPerc[eligibleAnnualPerc.length - 1]];

        const agent = await DataStore.query(User, contract.commercial?.id);

        const levelPerc = Percentages.ON_ROLE[agent.role];
        


        const totalBonus = contract.amount * (basePerc + capitalPerc + annualPerc) / 100;
        

        let bonusInput = {
            basePerc: basePerc,
            capitalPerc: capitalPerc,
            annualPerc: annualPerc,
            levelPerc: levelPerc,

            contractID: contract.id,
            // type: BonusType.MARKETING_FEE_1,
            payDate: this.getPaymentDate(contract.startDate),
        };

        // 1) agent bonus
        let directAgentBonus = totalBonus * levelPerc / 100;

        if (contract?.commercial.permessions == PermissionType.ADMINISTRATOR)
            directAgentBonus = totalBonus;
        
        const contractUser = await DataStore.query(User, contract.clientId);
        
        const directAgentBonusInput: Bonus = new Bonus({
            ...bonusInput,
            type: BonusType.MARKETING_FEE_1,
            typeEnum: BonusType.MARKETING_FEE_1,
            total: directAgentBonus,
            //userBonusId: agent.id
            date: contract.startDate,
            user: agent,
            status: BonusStatus.NON_PAGATO,
            info: contractUser?.lastname + ' ' + contractUser?.name,
        });
        // @ts-ignore
        // @ts-ignore
        const directAgentBonusInputFromSecondYear: any = {
            ...bonusInput,
            type: BonusType.MARKETING_FEE_1,
            typeEnum: BonusType.MARKETING_FEE_1,
            total: directAgentBonus / 2,
            userID: agent.id,
            status: BonusStatus.NON_PAGATO,
            info: contractUser?.lastname + ' ' + contractUser?.name,
        };

        for (let i = 0; i < contractDurationInYears; i++) {
            if (i == 0) {
                await DataStore.save(directAgentBonusInput);

            } else {
                var oneYearFromNow = DateTime.fromISO(directAgentBonusInput.payDate);
                oneYearFromNow = oneYearFromNow.plus({year: i});
                directAgentBonusInputFromSecondYear.payDate = oneYearFromNow.startOf('month').toISODate();
                directAgentBonusInputFromSecondYear.date = oneYearFromNow.toISODate();
                directAgentBonusInputFromSecondYear.info = contractUser?.lastname + ' ' + contractUser?.name + ' - ' + oneYearFromNow.year.toString();
                // @ts-ignore
                await DataStore.save(new Bonus({...directAgentBonusInputFromSecondYear}));

            }
        }
        let contractToUpdate = await DataStore.query(Contract, contract.id);
        await DataStore.save(Contract.copyOf(contractToUpdate, up => {
            up.bonusActiveFirstYear = directAgentBonus;
            up.bonusRecurrence = directAgentBonus / 2;
        }));

        


        // 2) upline 1 bonus (70%)
        try {
       let upline1Agent = null;
        if (agent.addedBy)
         upline1Agent = await DataStore.query(User, agent.addedBy);
        let percent = 0.7;
        if (upline1Agent) {
            if (upline1Agent.managerFeePercent )
            {
                percent = upline1Agent.managerFeePercent;
            }

            const upline1Bonus = (totalBonus - directAgentBonus) * percent;
            const upline1BonusInput: Bonus = new Bonus({
                ...bonusInput,
                type: BonusType.MANAGER_FEE_2,
                typeEnum: BonusType.MANAGER_FEE_2,
                total: upline1Bonus,
                //userBonusId: upline1Agent.id,
                date: contract.startDate,
                user: upline1Agent,
                status: BonusStatus.NON_PAGATO,
                info: agent.lastname + ' ' + agent.name,
            });
            await DataStore.save(upline1BonusInput);
            // 3) upline 2 bonus (30%)
            const upline2Bonus = (totalBonus - directAgentBonus - upline1Bonus);
            if (upline2Bonus <= 0)
                return;
            let upline2Agent = null;
            if (upline1Agent.addedBy) {
                upline2Agent = await DataStore.query(User, upline1Agent.addedBy);

                const upline2BonusInput: Bonus = new Bonus({
                    ...bonusInput,
                    type: BonusType.MANAGER_FEE_2,
                    typeEnum: BonusType.MANAGER_FEE_2,
                    total: upline2Bonus,
                    date: contract.date,
                    //userBonusId: upline2Agent.id,
                    user: upline2Agent,
                    status: BonusStatus.NON_PAGATO,
                    info: agent.lastname + ' ' + agent.name,
                });


                await DataStore.save(upline2BonusInput);
            } else {

                const upline2BonusInput: Bonus = new Bonus({
                    ...bonusInput,
                    type: BonusType.MANAGER_FEE_2,
                    typeEnum: BonusType.MANAGER_FEE_2,
                    total: upline2Bonus,
                    date: contract.date,
                    //userBonusId: upline2Agent.id,
                    user: upline1Agent,
                    status: BonusStatus.NON_PAGATO,
                    info: agent.lastname + ' ' + agent.name,
                });


                await DataStore.save(upline2BonusInput);
            }
        }





        } catch (e) {
            
        }
    }

    private dateDiffInDays(start, end): number {
        const a = new Date(start);
        const b = new Date(end);
        const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
        const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

        let retVal = Math.floor((utc2 - utc1) / (1000 * 60 * 60 * 24));
        
        return retVal;
    }

    private getLastDayOfCurrentMonth(date = null) {
        let today;
        if (date == null)
            today = new Date();
        else
            today = date;

        const d = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        return `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}`;
    }

    setPaymentDateAfter(fromDate, dayesNumber = 0) {

        fromDate.setDate(fromDate.getDate() + dayesNumber);

    }

    dateToAwsString(d) {
        return `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}`;
    }


    async activeContract(contract: Contract) {
        await this.setAgentLevel(contract.commercial.id, contract.amount);
        await this.calcMonthlyBonus(contract);
        await DataStore.save(Contract.copyOf(contract, up => {
            up.status = ContractStatus.ACTIVE;
        }));
    }

    private getPaymentDate(startDate: string) {
        let date = DateTime.fromISO(startDate);

        if (date.day>=20){
            return  DateTime.fromISO(startDate).plus({month:2}).startOf('month').toISODate();
        }else {
            return  DateTime.fromISO(startDate).plus({month:1}).startOf('month').toISODate();

        }
    }
}
